var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "message-search" },
    [
      _c(
        "div",
        { staticClass: "message-search-content" },
        [
          _c("a-input", {
            model: {
              value: _vm.searchQuery,
              callback: function ($$v) {
                _vm.searchQuery = $$v
              },
              expression: "searchQuery",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "search-results" },
        _vm._l(_vm.results, function (item) {
          return _c(
            "div",
            {
              staticClass: "result-item",
              on: {
                click: function ($event) {
                  return _vm.messageSelected(item)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "result-avatar" },
                [
                  item.messageType === "visitor"
                    ? _c("ContactAvatar", {
                        attrs: { contact: _vm.contact, size: "smallest" },
                      })
                    : item.messageType === "chatbot"
                    ? _c("ContactAvatar", {
                        attrs: { fullname: "Chatbot", size: "smallest" },
                      })
                    : !item.user
                    ? _c("ContactAvatar", {
                        attrs: { fullname: "User", size: "smallest" },
                      })
                    : _c("AgentAvatar", {
                        attrs: { userID: item.user._id, size: 35 },
                      }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "result-item-content" }, [
                _c("div", { staticClass: "user-detail" }, [
                  _c("div", { staticClass: "author" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          item.messageType === "visitor"
                            ? _vm.contact.fullname
                            : item.user
                            ? item.user.name
                            : item.messageType === "chatbot"
                            ? "Chatbot"
                            : "User"
                        ) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "date" }, [
                    _vm._v(
                      _vm._s(_vm.$moment(item.createdDate).format("HH:mm"))
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "message" }, [
                  _vm._v(_vm._s(_vm.SanitizeHtml(item.description, true))),
                ]),
              ]),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      !_vm.searchQuery.length
        ? _c("div", { staticClass: "messages-no-result" }, [
            _c("div", { staticClass: "material-icons" }, [_vm._v("search")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("message.searchPrompt")))]),
          ])
        : !_vm.results.length && _vm.searchQuery.length > 0
        ? _c("div", { staticClass: "messages-no-result" }, [
            _c("div", { staticClass: "material-icons" }, [
              _vm._v("mode_comment"),
            ]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("message.noRecentResults")))]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.searchQuery.length > 0
        ? _c(
            "SupsisButton",
            {
              staticClass: "load-more",
              attrs: { primary: "" },
              on: { click: _vm.loadMore },
            },
            [
              _c("div", { staticClass: "material-icons" }, [_vm._v("search")]),
              _vm._v(
                "\n        " + _vm._s(_vm.$t("message.loadMore")) + "\n    "
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }